(function () {
	'use strict';

	angular.module('qbePortal').directive('qbTooltip',
		function () {
			return {
				restrict: 'A',
				scope: {
					tooltip: '@'
				},
				link: function (scope, element, attrs) {
					element.attr('title', scope.tooltip);
					$('.js-tooltip').ddTooltip();
				}
			};
		});

})();
